export default __webpack_public_path__ + "static/media/donuts-no-1.b0ed86e3.ogg";